import { Close, ViewComfyRounded } from "@mui/icons-material";
import { Tooltip, IconButton, Dialog, DialogTitle, DialogContent } from "@mui/material/index";
import { useTranslation } from "react-i18next";
import { useState } from "react";
import CBBundleInfoGrid from "./CBBundleInfoGrid";
import { CB_BUNDLE_STEP_DOSSIER_KIND_MAP, IBundleInfoValues } from "../../../../types";

interface CBBundleInfoProps {
    bundleInfo: IBundleInfoValues
}

const CBBundleInfo = ({ bundleInfo }: CBBundleInfoProps) => {

    const { t } = useTranslation("customerbase");

    const [openInfoDialog, setOpenInfoDialog] = useState(false);

    return (
        <>
            <Dialog 
                open={openInfoDialog}
                fullWidth
                maxWidth="md"
            >
                <IconButton
                    sx={{
                        position: "absolute",
                        top: 12,
                        right: 12
                    }}
                    onClick={() => setOpenInfoDialog(false)}
                >
                <Close fontSize="inherit"/>  
                </IconButton>
                <DialogTitle>
                    {t(`attachmentKindType.${CB_BUNDLE_STEP_DOSSIER_KIND_MAP.find(m => m.key == bundleInfo.step?.toUpperCase())?.value}`, '')}
                </DialogTitle>
                <DialogContent>
                    <CBBundleInfoGrid bundleInfo={bundleInfo}/>
                </DialogContent> 
            </Dialog>
            <Tooltip title={t("tooltips.document.bundleInfoBtn")} arrow>
                <IconButton
                    color="accent"
                    onClick={() => setOpenInfoDialog(true)}
                >
                    <ViewComfyRounded fontSize="small"/>
                </IconButton>
            </Tooltip>
        </>
    )

}

export default CBBundleInfo;